module.exports = __webpack_public_path__ + "p2_img2.jpg?e46652cbe4bf226e589035e99c22ef89";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img2.jpg
// module id = 51
// module chunks = 0